export const setIsLoading = (state, value) => {
    state.isLoading = value;
};

export const setCtaDisabled = (state, value) => {
    state.isCtaDisabled = value;
};

export const setSelectedAccount = (state, value) => {
    state.selectedAccount = value;
};

export const setSaveForLater = (state, value) => {
    state.saveForLater = value;
};

export const setEditing = (state, value) => {
    state.editing = value;
};
